class EsimLocalizationMount extends HTMLElement {
  connectedCallback() {
    if (this._connected) return;

    this._desktop = this.querySelector('[data-esim-localization-desktop]');
    this._mobile = this.querySelector('[data-esim-localization-mobile]');
    this._onSectionLoad = () => this.mount();
    this._onHeaderClick = (event) => {
      if (event.target instanceof Element && event.target.closest('#header-group .header__icon--menu')) {
        this.mount();
      }
    };

    document.addEventListener('shopify:section:load', this._onSectionLoad);
    document.addEventListener('click', this._onHeaderClick, true);
    this._connected = true;

    customElements.whenDefined('esim-localization-switcher').then(() => {
      if (this.isConnected) this.mount();
    });
  }

  disconnectedCallback() {
    if (!this._connected) return;

    document.removeEventListener('shopify:section:load', this._onSectionLoad);
    document.removeEventListener('click', this._onHeaderClick, true);
    this.restore(this._desktop, this._desktopNative);
    this.restore(this._mobile, this._mobileNative);
    this._connected = false;
  }

  mount() {
    // Horizon 4.2.0 renders these native controls without a block insertion point.
    // Keep them in the DOM as the fallback when this enhancement cannot mount.
    const header = document.querySelector('#header-group #header-component');
    const desktopNative = header?.querySelector('dropdown-localization-component.dropdown-localization');
    const mobileNative = header?.querySelector(
      '.header__drawer header-drawer .menu-drawer__utility-links > drawer-localization-component'
    );

    this._desktopNative = this.mountControl(this._desktop, desktopNative, this._desktopNative);
    this._mobileNative = this.mountControl(this._mobile, mobileNative, this._mobileNative);
  }

  mountControl(picker, nativeControl, previousNative) {
    if (previousNative && previousNative !== nativeControl) {
      previousNative.classList.remove('esim-localization-native-hidden');
    }

    const hasBothControls = nativeControl?.querySelector('.country-selector-form__wrapper') &&
      nativeControl.querySelector('.language-selector');

    if (!picker || !hasBothControls) {
      this.restore(picker, nativeControl);
      return null;
    }

    if (nativeControl.nextElementSibling !== picker) nativeControl.after(picker);
    nativeControl.classList.add('esim-localization-native-hidden');
    return nativeControl;
  }

  restore(picker, nativeControl) {
    nativeControl?.classList.remove('esim-localization-native-hidden');
    if (picker && picker.parentElement !== this) this.append(picker);
  }
}

if (!customElements.get('esim-localization-mount')) {
  customElements.define('esim-localization-mount', EsimLocalizationMount);
}
